import axios, { AxiosInstance, AxiosResponse } from 'axios'
import type { App } from 'vue'
import { AxiosKey } from '@/symbols'
interface AxiosOptions {
    baseUrl: string
}

export default {
    install: (app: App, options: AxiosOptions) => {
        const axiosInstance = axios.create({
            baseURL: options.baseUrl,
        });

        axiosInstance.interceptors.response.use((response) => {
            return response;
         }, 
        //function (error) {
        //     if (error.response.status === 403 || error.response.status === 401 || error.response.status === 405) {
        //         window.location.href = window.location.origin + "/PayTickets/login";
        //     }
        //     return Promise.reject(error);
        // }
        );

        app.config.globalProperties.$axios = axiosInstance;
        app.provide(AxiosKey, axiosInstance);
    }
}

declare module "@vue/runtime-core" {
    interface ComponentCustomProperties {
        $axios: AxiosInstance
    }
}

